/*

*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "examples/Cards/InfoCards/SimpleInfoCard";

function Information() {
  return (
    <MKBox component="section" py={{ xs: 6, md: 12 }}>
      <Container>
        <Grid container item xs={12} justifyContent="center">
          <Grid
            item
            xs={12}
            md={4}
            sx={{ ml: { xs: 0, md: "auto" }, mr: { xs: 0, md: 6 }, mb: { xs: 4, md: 0 } }}
          >
            <Stack spacing={{ xs: 4, md: 8 }}>
              <SimpleInfoCard
                icon="lightbulb_outline"
                title="Soluções Customizadas"
                description="Da infraestrutura robusta à capacitação especializada, oferecemos soluções integradas e personalizadas, para a proteção completa e contínua da sua jornada digital."
              />
              <SimpleInfoCard
                icon="devices_other"
                title="Equipamentos Inovadores"
                description="Equipamentos de alta performance, desenvolvidos para otimizar comunicações e oferecer segurança robusta com máxima confiabilidade e eficiência."
              />
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ mr: { xs: 0, md: "auto" }, ml: { xs: 0, md: 6 }, mb: { xs: 4, md: 0 } }}
          >
            <Stack spacing={{ xs: 4, md: 8 }}>
              <SimpleInfoCard
                icon="access_alarms"
                title="Excelente Suporte"
                description="Equipe sempre à disposição, com acompanhamento especializado para lhe auxiliar a manter sua segurança digital sempre em alta."
              />
              <SimpleInfoCard
                icon="school"
                title="Impacto Internacional"
                description="Parcerias, e treinamentos, de excelência, preparando profissionais para enfrentar desafios globais em segurança cibernética com conhecimento avançado e prático."
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
